import {booleanAttribute, Component, input, output} from '@angular/core';

/**
 * ‹ label › stepper for days, weeks and periods. `sub` is a second line ("12 okt – 18 okt"),
 * `caption` a label above the control ("Periode"). Clicking the label emits `labelClick` (e.g. to open a calendar).
 */
@Component({
    selector: 'app-period-stepper',
    templateUrl: './period-stepper.component.html',
    styleUrl: './period-stepper.component.scss',
    host: {
        '[class.small]': 'size() === "sm"',
        '[class.mono]': 'mono()'
    }
})
export class PeriodStepperComponent {
    readonly label = input<string | number>('');
    readonly sub = input<string>();
    readonly caption = input<string>();
    readonly size = input<'sm' | 'md'>('md');
    readonly mono = input(false, {transform: booleanAttribute});
    readonly previousDisabled = input(false, {transform: booleanAttribute});
    readonly nextDisabled = input(false, {transform: booleanAttribute});
    readonly previousLabel = input('Vorige');
    readonly nextLabel = input('Volgende');

    readonly previous = output<void>();
    readonly next = output<void>();
    readonly labelClick = output<void>();
}
